import React, { Fragment, useMemo, useState } from "react";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import { makeStyles } from "@mui/styles";
import CommonTable from "../../common/commonTable";
import {
  totalOverdueByRegionTableListBody,
  totalOverdueByRegionTableListBodyDetailedHeader,
  totalOverdueByRegionTableListBodyMainView,
  totalOverdueByRegionTableListHeaderMainView,
  totalOverdueByStateTableListBody,
  totalOverdueByStateTableListBodyDetailedHeader,
  totalOverdueByStateTableListBodyMainView,
  totalOverdueByStateTableListHeaderMainView,
} from "../../common/ageingReportConstant";
import { useEffect } from "react";

import { Line } from "react-chartjs-2";
import { formatMoney } from "../../../constants/utils";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { Box, OutlinedInput } from "@mui/material";
import AgeingReportHistoryModal from "./ageingReportHistoryModal";
import CommonLoader from "../../common/commonLoader";
import CommonTableWithFooterFixed from "../../common/commonTableWithFooterFixed";
import {
  getAgeingHistoryReportDetailsByRegionNew,
  getAgeingHistoryReportDetailsByStateNew,
} from "../../api/ageingReportService";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const useStyles = makeStyles((theme) => ({
  cardbody: {
    padding: `${theme.spacing(1.8, 1.3)} !important`,
    [theme.breakpoints.down("sm")]: {
      padding: `${theme.spacing(0)} !important`,
      margin: `${theme.spacing(0, 1)} !important`,
    },
  },
}));

const AgeingReportHistoryOverdueSection = (props) => {
  const {
    totalOverdueByStateByMonthList,
    totalOverdueByRegionByMonthList,
    searchData,
  } = props;

  const classes = useStyles();
  const [
    totalOverdueByRegionTableListData,
    setTotalOverdueByRegionTableListData,
  ] = useState([]);

  const [modalData, setModalData] = useState([]);
  const [rowData, setRowData] = useState(null);
  const [isRegion, setIsRegion] = useState(false);
  const [loading, setLoading] = useState(false);

  const [activeTab, setActiveTab] = useState("1");
  const [showDetailedView, setShowDetailedView] = useState(false);
  const [showDetailedViewState, setShowDetailedViewState] = useState(false);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const processChartDataForRegion = (data) => {
    // Extract unique months (x-axis labels)
    const months = [...new Set(data.map((item) => item.monthName))];

    // Extract unique regions
    const regions = [...new Set(data.map((item) => item.regionName))];

    // Create datasets for each region
    const datasets = regions.map((region) => ({
      label: region,
      backgroundColor: "transparent",
      borderColor: getColor(region),
      pointBackgroundColor: getColor(region),
      data: months.map((month) => {
        const entry = data.find(
          (item) => item.monthName === month && item.regionName === region,
        );
        return entry ? entry.totalOverdue : 0; // Default to 0 if missing
      }),
      lineTension: 0.4,
    }));

    // Calculate total across all regions for each month
    const totalDataset = {
      label: "Total",
      backgroundColor: "transparent",
      borderColor: "#333333",
      pointBackgroundColor: "#333333",
      data: months.map((month) => {
        return data
          .filter((item) => item.monthName === month)
          .reduce((sum, item) => sum + (item.totalOverdue || 0), 0);
      }),
      lineTension: 0.4,
    };
    return {
      labels: months,
      datasets,
      datasetsForList: [...datasets, totalDataset],
    };
  };

  // Function to assign colors dynamically
  const getColor = (region) => {
    const colorMap = {
      West: "#0e87d7",
      North: "#b255ec",
      East: "#a6b90e",
      South: "#d7600e",
    };
    return colorMap[region];
  };

  // BY REGION STARTS
  const lineChartByFinancialYearData = processChartDataForRegion(
    totalOverdueByRegionByMonthList,
  );

  useEffect(() => {
    //console.log(lineChartByFinancialYearData);
    if (
      lineChartByFinancialYearData?.datasets &&
      lineChartByFinancialYearData?.datasets.length > 0
    ) {
      /*       const newTitle = ["Region", ...lineChartByFinancialYearData.labels];

      //console.log(lineChartByFinancialYearData, "lineChartByFinancialYearData");

      setTotalOverdueByRegionTableListHeader((prevTitle) =>
        JSON.stringify(prevTitle) !== JSON.stringify(newTitle)
          ? newTitle
          : prevTitle
      ); */
      console.log(
        lineChartByFinancialYearData?.datasetsForList,
        "lineChartByFinancialYearData?.datasetsForList",
      );
      const transformedData = lineChartByFinancialYearData?.datasetsForList.map(
        (item) => {
          return {
            regionName: item.label,
            marMonthVal: formatMoney(item.data[0]),
            aprMonthVal: formatMoney(item.data[1]),
            mayMonthVal: formatMoney(item.data[2]),
            junMonthVal: formatMoney(item.data[3]),
            julMonthVal: formatMoney(item.data[4]),
            augMonthVal: formatMoney(item.data[5]),
            sepMonthVal: formatMoney(item.data[6]),
            octMonthVal: formatMoney(item.data[7]),
            novMonthVal: formatMoney(item.data[8]),
            decMonthVal: formatMoney(item.data[9]),
            janMonthVal: formatMoney(item.data[10]),
            febMonthVal: formatMoney(item.data[11]),
            liveMonthVal: formatMoney(item.data[12]),
          };
        },
      );

      setTotalOverdueByRegionTableListData((prevData) =>
        JSON.stringify(prevData) !== JSON.stringify(transformedData)
          ? transformedData
          : prevData,
      );
    }
  }, [lineChartByFinancialYearData]);

  const lineChartByFinancialYearOption = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        labels: {
          usePointStyle: true, // Enables circular legend icons
          boxWidth: 10, // Adjusts size
          color: "#000",
        },
      },
    },
    scales: {
      xAxes: {
        gridLines: {
          color: "#f8f8f8",
        },
      },
      yAxes: {
        gridLines: {
          color: "#f8f8f8",
        },
      },
    },
  };

  // BY REGION ENDS

  // 27 unique background colors
  const backgroundColors = [
    "#1a139f",
    "#ff6384",
    "#36a2eb", //Bihar
    "#ffce56",
    "#4bc0c0",
    "#9966ff",
    "#ff9f40",
    "#e74c3c",
    "#2ecc71",
    "#f39c12",
    "#9b59b6",
    "#8e44ad",
    "#2c3e50",
    "#d35400",
    "#16a085",
    "#c0392b",
    "#7f8c8d",
    "#e67e22",
    "#2980b9",
    "#f1c40f",
    "#27ae60",
    "#34495e",
    "#dc7633",
    "#f1948a",
    "#84697d", //#5dade2 UP
    "#58d68d",
    "#9fb6a0",
  ];

  // BY STATE STARTS

  const [selectedStateName, setSelectedStateName] = useState([
    "Bihar",
    "Uttar Pradesh",
  ]);
  /*   const [stateList, setStateList] = useState([
    ...new Set(totalOverdueByStateByMonthList.map((item) => item.stateName)),
  ]); */
  const stateList = useMemo(() => {
    const uniqueStates = [
      ...new Set(totalOverdueByStateByMonthList.map((item) => item.stateName)),
    ];

    return ["Select All", ...uniqueStates];
    /* return [
      ...new Set(totalOverdueByStateByMonthList.map((item) => item.stateName)),
    ]; */
  }, [totalOverdueByStateByMonthList]);

  const [
    totalOverdueByStateTableListData,
    setTotalOverdueByStateTableListData,
  ] = useState([]);

  const processChartDataForState = (data) => {
    // Extract unique months (x-axis labels)
    const months = [...new Set(data.map((item) => item.monthName))];

    // Extract unique regions
    const states = [...new Set(data.map((item) => item.stateName))];

    // Create datasets for each region
    const datasets = states.map((state, index) => ({
      label: state,
      backgroundColor: "transparent",
      borderColor: backgroundColors[index],
      pointBackgroundColor: backgroundColors[index],
      data: months.map((month) => {
        const entry = data.find(
          (item) => item.monthName === month && item.stateName === state,
        );
        return entry ? entry.totalOverdue : 0; // Default to 0 if missing
      }),
      lineTension: 0.4,
    }));

    /*  // Calculate total across all regions for each month
    const totalDataset = {
      label: "Total",
      backgroundColor: "transparent",
      borderColor: "#333333",
      pointBackgroundColor: "#333333",
      data: months.map((month) => {
        return data
          .filter((item) => item.monthName === month)
          .reduce((sum, item) => sum + (item.totalOverdue || 0), 0);
      }),
      lineTension: 0.4,
    };
 */
    return {
      labels: months,
      datasets,
      //datasetsForList: [...datasets, totalDataset],
    };
  };

  const lineChartByFinancialYearDataState = processChartDataForState(
    totalOverdueByStateByMonthList,
  );

  const filteredDatasets = lineChartByFinancialYearDataState.datasets.filter(
    (dataset) => selectedStateName.includes(dataset.label),
  );

  /* const lineChartByFinancialYearDataStateFiltered = {
    ...lineChartByFinancialYearDataState,
    datasets: filteredDatasets,
  }; */
  const lineChartByFinancialYearDataStateFiltered = useMemo(() => {
    return {
      ...lineChartByFinancialYearDataState,
      datasets: filteredDatasets,
    };
  }, [lineChartByFinancialYearDataState, filteredDatasets]);

  const getTotalValueForState = (processedChartData, index) => {
    return formatMoney(
      processedChartData.datasets.reduce(
        (sum, item) => sum + (item.data[index] || 0),
        0,
      ),
    );
  };

  // This is for table state wise
  useEffect(() => {
    if (
      lineChartByFinancialYearDataState?.datasets &&
      lineChartByFinancialYearDataState?.datasets.length > 0
    ) {
      const processedChartData = lineChartByFinancialYearDataState;
      /* const processedChartData =
        selectedStateName.length > 0
          ? lineChartByFinancialYearDataStateFiltered
          : lineChartByFinancialYearDataState; */

      //const newTitle = ["State", ...processedChartData.labels];

      /*       setTotalOverdueByStateTableListHeader((prevTitle) =>
        JSON.stringify(prevTitle) !== JSON.stringify(newTitle)
          ? newTitle
          : prevTitle
      );
 */
      console.log(
        lineChartByFinancialYearDataState,
        "lineChartByFinancialYearDataState",
      );
      const transformedData = processedChartData?.datasets.map((item) => {
        return {
          stateName: item.label,
          marMonthVal: formatMoney(item.data[0]),
          aprMonthVal: formatMoney(item.data[1]),
          mayMonthVal: formatMoney(item.data[2]),
          junMonthVal: formatMoney(item.data[3]),
          julMonthVal: formatMoney(item.data[4]),
          augMonthVal: formatMoney(item.data[5]),
          sepMonthVal: formatMoney(item.data[6]),
          octMonthVal: formatMoney(item.data[7]),
          novMonthVal: formatMoney(item.data[8]),
          decMonthVal: formatMoney(item.data[9]),
          janMonthVal: formatMoney(item.data[10]),
          febMonthVal: formatMoney(item.data[11]),
          liveMonthVal: formatMoney(item.data[12]),
        };
      });

      /*  setTotalOverdueByStateTableListData((prevData) =>
        JSON.stringify(prevData) !== JSON.stringify(transformedData)
          ? transformedData
          : prevData
      ); */
      // ➕ Add a Total row
      const totalRow = {
        stateName: "Total",
        aprMonthVal: getTotalValueForState(processedChartData, 0),
        mayMonthVal: getTotalValueForState(processedChartData, 1),
        junMonthVal: getTotalValueForState(processedChartData, 2),
        julMonthVal: getTotalValueForState(processedChartData, 3),
        augMonthVal: getTotalValueForState(processedChartData, 4),
        sepMonthVal: getTotalValueForState(processedChartData, 5),
        octMonthVal: getTotalValueForState(processedChartData, 6),
        novMonthVal: getTotalValueForState(processedChartData, 7),
        decMonthVal: getTotalValueForState(processedChartData, 8),
        janMonthVal: getTotalValueForState(processedChartData, 9),
        febMonthVal: getTotalValueForState(processedChartData, 10),
        marMonthVal: getTotalValueForState(processedChartData, 11),
        liveMonthVal: getTotalValueForState(processedChartData, 12),
      };

      const finalData = [...transformedData, totalRow];

      setTotalOverdueByStateTableListData((prevData) =>
        JSON.stringify(prevData) !== JSON.stringify(finalData)
          ? finalData
          : prevData,
      );
    }
  }, [
    lineChartByFinancialYearDataState,
    selectedStateName,
    lineChartByFinancialYearDataStateFiltered,
  ]);

  const lineChartByFinancialYearOptionState = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        labels: {
          usePointStyle: true, // Enables circular legend icons
          boxWidth: 10, // Adjusts size
          color: "#000",
        },
      },
    },
    scales: {
      xAxes: {
        gridLines: {
          color: "#f8f8f8",
        },
      },
      yAxes: {
        gridLines: {
          color: "#f8f8f8",
        },
      },
    },
  };

  // BY STATE ENDS

  const [open, setOpen] = useState(false);

  const onOpenModalRegion = (row) => {
    const filteredItem = totalOverdueByRegionByMonthList.find(
      (item) => item.regionName === row.regionName,
    );
    const regionMasterId = filteredItem.regionMasterId;
    setIsRegion(true);
    if (regionMasterId) {
      setLoading(true);
      const divisionId = searchData.searchDivision ?? "";
      const asmLoginId = searchData.searchAsm ?? "";
      getAgeingHistoryReportDetailsByRegionNew(
        regionMasterId,
        divisionId,
        asmLoginId,
      ).then((res) => {
        setLoading(false);
        setModalData(
          res.response.responseMap.ageingReportsWithDivisionByRegion,
        );
        //setOpen
        setRowData(row);
        setOpen(true);
      });
    }
  };

  const onOpenModalState = (row) => {
    setIsRegion(false);
    const filteredItem = totalOverdueByStateByMonthList.find(
      (item) => item.stateName === row.stateName,
    );
    const stateMasterId = filteredItem.stateMasterId;

    if (stateMasterId) {
      setLoading(true);
      const divisionId = searchData.searchDivision ?? "";
      const asmLoginId = searchData.searchAsm ?? "";
      getAgeingHistoryReportDetailsByStateNew(
        stateMasterId,
        divisionId,
        asmLoginId,
      ).then((res) => {
        setLoading(false);
        //setModalData(res.response.responseObject);
        setModalData(res.response.responseMap.ageingReportsWithDivisionByState);
        setRowData(row);
        setOpen(true);
      });
    }
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    /* setSelectedStateName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    ); */
    const isString = typeof value === "string";
    const selected = isString ? value.split(",") : value;
    const allStatesExceptSelectAll = stateList.filter(
      (s) => s !== "Select All",
    );

    // Case 1: User just unchecked "Select All"
    const isUncheckingSelectAll =
      selected.includes("Select All") === false &&
      selected.length < selectedStateName.length &&
      selectedStateName.includes("Select All");

    if (isUncheckingSelectAll) {
      setSelectedStateName([]);
      return;
    }

    // Case 2: User checked "Select All"
    if (selected.includes("Select All")) {
      setSelectedStateName(stateList); // select all
      return;
    }

    // Case 3: User manually selected all states except "Select All"
    const filtered = selected.filter((s) => s !== "Select All");
    if (
      filtered.length === allStatesExceptSelectAll.length &&
      !selected.includes("Select All")
    ) {
      setSelectedStateName(stateList); // auto-add "Select All"
    } else {
      setSelectedStateName(filtered); // normal case
    }
  };
  return (
    <Fragment>
      {loading ? <CommonLoader /> : null}
      {/* <!-- Container-fluid starts--> */}
      <Container fluid={true}>
        <Row>
          <TabContext value={activeTab}>
            <TabList
              onChange={handleTabChange}
              aria-label="lab API tabs example"
              indicatorColor="secondary"
              textColor="secondary"
              style={{ background: "white" }}
            >
              <Tab label="By Region" value="1" />
              <Tab label="By State" value="2" />
            </TabList>
            {/* By Region Section Starts*/}
            <TabPanel value="1">
              <Card>
                <CardBody className={classes.cardbody}>
                  <Row>
                    <Col sm="12">
                      <Card>
                        <h5>
                          <h5>Trend for L12M</h5>
                        </h5>
                        <CardBody className="sell-graph">
                          <Line
                            data={lineChartByFinancialYearData}
                            options={lineChartByFinancialYearOption}
                            width={700}
                            height={350}
                          />
                        </CardBody>
                      </Card>
                    </Col>
                    <Col sm="12">
                      <Card>
                        <CardBody className="sell-graph">
                          <Box display={"flex"}>
                            <Button
                              style={{
                                marginLeft: 10,
                                marginBottom: 4,
                                width: 250,
                              }}
                              color="dark"
                              variant="contained"
                              type="button"
                              onClick={() =>
                                setShowDetailedView(!showDetailedView)
                              }
                            >
                              {`View ${
                                !showDetailedView ? "Detailed" : "Main"
                              } data`}
                            </Button>
                          </Box>
                          <CommonTableWithFooterFixed
                            tableData={totalOverdueByRegionTableListData.filter(
                              ({ regionName }) =>
                                regionName?.toLowerCase() !== "total",
                            )}
                            tableHeaders={
                              showDetailedView
                                ? totalOverdueByRegionTableListBodyDetailedHeader
                                : totalOverdueByRegionTableListHeaderMainView
                            }
                            tableColumns={
                              showDetailedView
                                ? totalOverdueByRegionTableListBody
                                : totalOverdueByRegionTableListBodyMainView
                            }
                            editId={"regionMasterId"}
                            editMode={true}
                            onOpenModal={onOpenModalRegion}
                            rowsPerPageOptions={[25, 50, 100]}
                            count={totalOverdueByRegionTableListData.length}
                            rowsPerPage={25}
                            page={0}
                            displayPagination={false}
                            tableFooterData={totalOverdueByRegionTableListData.filter(
                              ({ regionName }) =>
                                regionName?.toLowerCase() === "total",
                            )}
                          />
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </TabPanel>
            {/* By Region Section Ends*/}
            {/* By State Section Starts*/}
            <TabPanel value="2">
              <Row>
                <Col sm="12">
                  <div>
                    <FormControl sx={{ mt: 1, mb: 2, width: 600 }}>
                      <InputLabel
                        id="demo-multiple-checkbox-label"
                        sx={{ top: -8 }}
                      >
                        Select State
                      </InputLabel>
                      <Select
                        labelId="demo-multiple-checkbox-label"
                        id="demo-multiple-checkbox"
                        multiple
                        value={selectedStateName}
                        onChange={handleChange}
                        input={<OutlinedInput label="Select State" />}
                        renderValue={(selected) => selected.join(", ")}
                        MenuProps={MenuProps}
                      >
                        {stateList.map((name) => (
                          <MenuItem key={name} value={name}>
                            <Checkbox
                              checked={selectedStateName.includes(name)}
                            />
                            <ListItemText primary={name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  {selectedStateName.length > 0 && (
                    <Card>
                      <h5>Trend for L12M</h5>
                      <CardBody className="sell-graph">
                        <Line
                          data={lineChartByFinancialYearDataStateFiltered}
                          options={lineChartByFinancialYearOptionState}
                          width={700}
                          height={350}
                        />
                      </CardBody>
                    </Card>
                  )}
                </Col>
                <Col sm="12">
                  <Card>
                    <CardBody style={{ padding: "2px" }} className="sell-graph">
                      <Box display={"flex"}>
                        <Button
                          style={{
                            marginLeft: 10,
                            marginBottom: 4,
                            width: 250,
                          }}
                          color="dark"
                          variant="contained"
                          type="button"
                          onClick={() =>
                            setShowDetailedViewState(!showDetailedViewState)
                          }
                        >
                          {`View ${
                            !showDetailedViewState ? "Detailed" : "Main"
                          } data`}
                        </Button>
                      </Box>
                      <CommonTableWithFooterFixed
                        tableData={totalOverdueByStateTableListData.filter(
                          ({ stateName }) =>
                            stateName?.toLowerCase() !== "total",
                        )}
                        tableHeaders={
                          showDetailedViewState
                            ? totalOverdueByStateTableListBodyDetailedHeader
                            : totalOverdueByStateTableListHeaderMainView
                        }
                        tableColumns={
                          showDetailedViewState
                            ? totalOverdueByStateTableListBody
                            : totalOverdueByStateTableListBodyMainView
                        }
                        editId={"stateMasterId"}
                        editMode={true}
                        onOpenModal={onOpenModalState}
                        rowsPerPageOptions={[25, 50, 100]}
                        count={totalOverdueByStateTableListData.length}
                        rowsPerPage={25}
                        page={0}
                        displayPagination={false}
                        tableFooterData={totalOverdueByStateTableListData.filter(
                          ({ stateName }) =>
                            stateName?.toLowerCase() === "total",
                        )}
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPanel>
            {/* By State Section Ends*/}
          </TabContext>
        </Row>

        <AgeingReportHistoryModal
          open={open}
          onCancel={() => {
            setOpen(false);
            setRowData(null);
            setModalData([]);
            setIsRegion(false);
          }}
          modalData={modalData}
          title={`${
            rowData && (isRegion ? rowData?.regionName : rowData?.stateName)
          } - Ageing Report`}
        />
      </Container>
    </Fragment>
  );
};

export default AgeingReportHistoryOverdueSection;
